import { NEXT_PUBLIC_BIGCOMMERCE_CHANNEL_COUNTRY } from '@utils/client-side-config'

type TUnitsSystem = 'metric' | 'imperial'

enum UNIT_SYSTEMS {
  IMPERIAL = 'imperial',
  METRIC = 'metric',
}

const getPreferredUnitsSystem = (): TUnitsSystem => {
  return NEXT_PUBLIC_BIGCOMMERCE_CHANNEL_COUNTRY !== 'US'
    ? UNIT_SYSTEMS.METRIC
    : UNIT_SYSTEMS.IMPERIAL
}

const formatSizeLabel = ({
  label,
  isModifierOn,
}: {
  label: string
  isModifierOn: boolean
}) => {
  const preferredUnitSystem = getPreferredUnitsSystem()

  const swithToAlternativeLabel = isModifierOn
  const [metricUnits, imperialUnits] = label.split(' (')
  // If imperialUnits is not present, we will fallback to metricUnits as a default one
  // In practice, it means that the size option label is malformed or is a custom one, like e.g. "Custom size", and can not be split into metric and imperial units
  const formattedImperialUnits = imperialUnits
    ? imperialUnits.replace(')', '')
    : metricUnits

  if (preferredUnitSystem === UNIT_SYSTEMS.METRIC) {
    return swithToAlternativeLabel ? formattedImperialUnits : metricUnits
  }

  return swithToAlternativeLabel ? metricUnits : formattedImperialUnits
}

const applyRegionSpecificUnits = ({
  optionName,
  label,
  fieldModifiers,
}: {
  optionName: string
  label: string
  fieldModifiers: Record<string, boolean>
}) => {
  if (optionName?.toLowerCase()?.includes('size')) {
    return formatSizeLabel({
      label,
      isModifierOn: fieldModifiers?.size,
    })
  }

  return label
}

const isSizeLabelInStandardFormat = (label: string) => {
  const [metricUnits, imperialUnits] = label.split(' (')

  if (!imperialUnits) {
    return false
  }

  if (!metricUnits.includes('mm') || imperialUnits.includes('″')) {
    return false
  }

  return true
}

export {
  applyRegionSpecificUnits,
  getPreferredUnitsSystem,
  isSizeLabelInStandardFormat,
  UNIT_SYSTEMS,
}

export type { TUnitsSystem }
